var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Input as $Input } from "antd";
import { Field } from "formik";
import * as React from "react";
export var Input = function (_a) {
    var name = _a.name, validate = _a.validate, $onChange = _a.onChange, $onBlur = _a.onBlur, question = _a.question, restProps = __rest(_a, ["name", "validate", "onChange", "onBlur", "question"]);
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var _b = _a.field, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur;
        return (React.createElement($Input, __assign({ name: name, 
            // value={value}
            onChange: function (event) {
                onChange(event);
                $onChange && $onChange(event);
            }, onBlur: function (event) {
                onBlur(event);
                $onBlur && $onBlur(event);
            } }, restProps, { type: "text" })));
    }));
};
export default Input;
Input.Password = function (_a) {
    var name = _a.name, validate = _a.validate, $onChange = _a.onChange, $onBlur = _a.onBlur, restProps = __rest(_a, ["name", "validate", "onChange", "onBlur"]);
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var _b = _a.field, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur;
        return (React.createElement($Input.Password, __assign({ name: name, value: value, onChange: function (event) {
                onChange(event);
                $onChange && $onChange(event);
            }, onBlur: function (event) {
                onBlur(event);
                $onBlur && $onBlur(event);
            } }, restProps)));
    }));
};
Input.TextArea = function (_a) {
    var name = _a.name, validate = _a.validate, $onChange = _a.onChange, $onBlur = _a.onBlur, restProps = __rest(_a, ["name", "validate", "onChange", "onBlur"]);
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var _b = _a.field, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur;
        return (React.createElement($Input.TextArea, __assign({ name: name, value: value, onChange: function (event) {
                onChange(event);
                $onChange && $onChange(event);
            }, onBlur: function (event) {
                onBlur(event);
                $onBlur && $onBlur(event);
            } }, restProps)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Input/Input.tsx
// module id = 1391
// module chunks = 0